export const checkIsPlace = ({ properties }: any) => !properties.code;

export const checkIsSelectedStation = (stationCode: string, selectedStationCode: string) => (
  selectedStationCode && (stationCode === selectedStationCode)
);

export const checkIsCluster = ({ properties }: any) => !!properties.cluster;
